var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userAvatar)?_c('b-avatar',{staticClass:"mr-3 avatar avatar-md rounded-circle",attrs:{"variant":"info","src":_vm.userAvatar}}):_c('b-avatar',{staticClass:"mr-3",attrs:{"variant":"primary","text":_vm.userInitials}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }